import React, { useEffect, useState } from 'react';
import { FieldArrayRenderProps } from 'formik';
import ReactMarkdown from 'react-markdown';
import { Button } from 'react-bootstrap';
import Text from 'common/components/Text/Text';
import { CommonHash } from 'app/types';
import styles from '../LandingForm.module.scss';
import rehypeRaw from 'rehype-raw';
import MDEditor from '@uiw/react-md-editor';

interface SubComponentFormProps {
  landing_component: CommonHash;
  index: number;
  name: string;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  arrayHelpers: FieldArrayRenderProps;
  limit: number;
}

const SimpleCardForm = ({
  landing_component,
  index,
  name,
  handleChange,
  arrayHelpers,
  limit,
}: SubComponentFormProps): React.ReactElement => {
  const [markdownText, setMarkdownText] = useState(
    landing_component.sub_landing_components[index]['config'].card_text || ''
  );
  useEffect(() => {
    handleChange({
      target: {
        name: `${name}[${index}].config['card_text']`,
        value: markdownText,
      },
    });
  }, [markdownText]);
  return (
    <>
      <Text size={22}> Simple Card {index + 1} </Text>
      <div className="d-flex flex-column gap-3 mt-2">
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['icon_name']`}>Icon name</label>
          <input
            name={`${name}[${index}].config['icon_name']`}
            placeholder="Boostrap icon name"
            onChange={handleChange}
            value={landing_component.sub_landing_components[index]['config']['icon_name'] || ''}
          />
        </div>
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['icon_style']`}>Icon Style</label>
          <select
            name={`${name}[${index}].config['icon_style']`}
            onChange={handleChange}
            value={
              landing_component.sub_landing_components[index]['config']['icon_style']
                ? landing_component.sub_landing_components[index]['config']['icon_style']
                : 'on_top'
            }
          >
            <option value="on_top">Icon on top</option>
            <option value="inline">Inline</option>
          </select>
        </div>
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['card_title']`}>Card Title</label>
          <input
            name={`${name}[${index}].config['card_title']`}
            placeholder="Card Title"
            onChange={handleChange}
            value={landing_component.sub_landing_components[index]['config']['card_title'] || ''}
          />
        </div>
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['card_text']`}>Card Text</label>
          <MDEditor value={markdownText} onChange={setMarkdownText} />
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdownText}</ReactMarkdown>
        </div>
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['card_background']`}>Card Background</label>
          <input
            name={`${name}[${index}].config['card_background']`}
            placeholder="Card background"
            onChange={handleChange}
            value={
              landing_component.sub_landing_components[index]['config']['card_background'] || ''
            }
          />
        </div>
        <Button
          type="button"
          variant="danger"
          className={styles.deleteButton}
          onClick={() => {
            arrayHelpers.remove(index);
          }}
        >
          Delete
        </Button>
      </div>
      {index === landing_component.sub_landing_components.length - 1 &&
        landing_component.sub_landing_components.length <= limit - 1 && (
          <Button
            type="button"
            className="mt-3"
            variant="success"
            onClick={() =>
              arrayHelpers.push({
                config: {
                  icon_name: '',
                  icon_style: 'on_top',
                  card_title: '',
                  card_text: '',
                  card_background: 'transparent',
                },
              })
            }
          >
            + Simple Card
          </Button>
        )}
    </>
  );
};

export default SimpleCardForm;
